import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../common/containers/icon';
const ErrorDetailsToggle = _ref => {
  let _ref$hint = _ref.hint,
    hint = _ref$hint === void 0 ? '' : _ref$hint,
    _ref$technicalDetail = _ref.technicalDetail,
    technicalDetail = _ref$technicalDetail === void 0 ? '' : _ref$technicalDetail,
    _ref$reference = _ref.reference,
    reference = _ref$reference === void 0 ? '' : _ref$reference,
    _ref$errorCode = _ref.errorCode,
    errorCode = _ref$errorCode === void 0 ? '' : _ref$errorCode;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  const panelId = useId();
  const hasDetails = hint.length || technicalDetail.length || reference.length || errorCode.length;
  if (!hasDetails) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "t-error-details"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "t-error-details-toggle",
    "aria-label": expanded ? 'Hide error details' : 'Show error details',
    "aria-expanded": expanded,
    "aria-controls": panelId,
    onClick: () => setExpanded(open => !open)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "info-circle",
    ariaLabel: "Error details"
  }))), expanded ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-panel",
    id: panelId
  }, hint.length ? /*#__PURE__*/React.createElement("div", null, hint) : null, technicalDetail.length ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-technical"
  }, technicalDetail) : null, reference.length ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-reference"
  }, "Reference: ".concat(reference)) : null, errorCode.length ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-code"
  }, "Code: ".concat(errorCode)) : null) : null);
};
ErrorDetailsToggle.propTypes = {
  hint: PropTypes.string,
  technicalDetail: PropTypes.string,
  reference: PropTypes.string,
  errorCode: PropTypes.string
};
export default ErrorDetailsToggle;